import { Button, Collapse, FormGroup, Label, Input } from "reactstrap"
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { toggleColumn } from "../../../redux/columnsSlice"
import colors from "../formColors"
import { resetColumns, changeColumn } from "../../../redux/researchSlice"

const SelectColumns = () => {
    const forms = useSelector(state => state.forms);
    const researchData = useSelector(state => state.research);
    const columns = useSelector(state => state.columns);
    const dispatch = useDispatch();

    const [showColumns, setShowColumns] = useState(true)
    const toggleCollapse = () => setShowColumns(!showColumns)

    let mappableColumns = []

    if (columns.length) {
        mappableColumns = Object.values(columns);
    }

    useEffect(() => {
        if (researchData.tables.length) {
            // dispatch(resetColumns());
            for (let i = 0; i < mappableColumns.length; i++) {
                const currentColumn = mappableColumns[i];
                const mappableObject = Object.entries(currentColumn);
                let filteredColumns = mappableObject.filter((val) => val[1] === true);
                filteredColumns = filteredColumns.map(val => val[0]);
                // console.log("filteredColumns ==",filteredColumns);
                dispatch(changeColumn({ index: i, columns: filteredColumns }));
            }
        }
    }, [JSON.stringify(columns), JSON.stringify(researchData)])

    return (
        <div style={{ padding: "0px 0px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "12px 0px" }}>
                <h5 style={{ margin: 0 }}>Sélectionner colonnes</h5>
                <Button color="light" onClick={toggleCollapse}>
                    <i style={iconStyle}
                        className={`${!showColumns ? "ti-plus" : "ti-minus"}`}
                    />
                </Button>
            </div>

            <Collapse isOpen={showColumns} className="query-select flex">
                {forms.map((name, i) => {

                    if (!mappableColumns[i]) return <></>;

                    const mappableObject = Object.entries(mappableColumns[i]);
                    // console.log("mappableObject ==",mappableObject);

                    return <div className="flex-1 p-3 flex flex-col gap-6" style={{ background: colors[i % 4] }}>
                        <div className="font-bold text-lg">
                            {name}
                        </div>
                        <div>
                            {mappableObject.map(([key, val]) => <CheckBox
                                name={key}
                                checked={val}
                                onClick={() => dispatch(toggleColumn({ index: i, key }))} />)}
                        </div>
                    </div>
                })}
            </Collapse>
        </div>
    )
}

const iconStyle = {
    fontWeight: "bolder",
    fontSize: "16px",
};

function CheckBox({ name, checked, onClick }) {
    return <FormGroup check>
        <Label className="w-auto" check>
            <Input onClick={onClick} type="checkbox" checked={checked} />{' '}
            <div className="pl-2">
                {name}
            </div>
        </Label>
    </FormGroup>
}


export default SelectColumns
